/** An LLM provider whose API works like OpenAI's chat API, which is what our agent speaks. */
export type LlmProvider = {
    id: string;
    name: string;
    /** The API's base address. Empty for "Other", where you fill it in yourself. */
    url: string;
    /** A model this provider has, to show what a model name looks like there. */
    exampleModel: string;
};

/** The providers you can pick from. Each one was checked to answer OpenAI-style chat requests at this address. */
export const LLM_PROVIDERS: LlmProvider[] = [
    {
        id: "openrouter",
        name: "OpenRouter (models from every provider)",
        url: "https://openrouter.ai/api/v1",
        exampleModel: "anthropic/claude-sonnet-5.5",
    },
    { id: "anthropic", name: "Anthropic (Claude)", url: "https://api.anthropic.com/v1", exampleModel: "claude-sonnet-5-5" },
    { id: "openai", name: "OpenAI (GPT)", url: "https://api.openai.com/v1", exampleModel: "gpt-6.1-sol" },
    {
        id: "google",
        name: "Google (Gemini)",
        url: "https://generativelanguage.googleapis.com/v1beta/openai",
        exampleModel: "gemini-3.8-flash",
    },
    { id: "xai", name: "xAI (Grok)", url: "https://api.x.ai/v1", exampleModel: "grok-4.7" },
    { id: "mistral", name: "Mistral", url: "https://api.mistral.ai/v1", exampleModel: "mistral-large-latest" },
    { id: "deepseek", name: "DeepSeek", url: "https://api.deepseek.com/v1", exampleModel: "deepseek-chat" },
    { id: "groq", name: "Groq", url: "https://api.groq.com/openai/v1", exampleModel: "llama-3.3-70b-versatile" },
    { id: "other", name: "Other, like Ollama or vLLM", url: "", exampleModel: "qwen3:8b" },
];

/** The provider with this API address, or "Other" when it's none of them. */
export function findProvider(url: string): LlmProvider {
    const normal = (address: string) => address.trim().replace(/\/+$/, "");

    return LLM_PROVIDERS.find((provider) => provider.url && normal(provider.url) === normal(url)) ?? LLM_PROVIDERS.at(-1)!;
}
